<template>
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="60" height="60" rx="5" fill="#F0783B"/>
    <path d="M30.0742 35.625V29.375" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M33.125 32.5H26.875" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M42.5 28.75V36.25C42.5 41.25 41.25 42.5 36.25 42.5H23.75C18.75 42.5 17.5 41.25 17.5 36.25V23.75C17.5 18.75 18.75 17.5 23.75 17.5H25.625C27.5 17.5 27.9125 18.05 28.625 19L30.5 21.5C30.975 22.125 31.25 22.5 32.5 22.5H36.25C41.25 22.5 42.5 23.75 42.5 28.75Z" stroke="white" stroke-width="2" stroke-miterlimit="10"/>
  </svg>
</template>

<script>
import iconMixin from "@/services/iconMixins.js";

export default {
  mixins: [iconMixin]
};
</script>
